import { useNestedSidebar } from '@monorepo/controlled/src/hooks/use-nested-sidebar';
import { useRoute } from '@monorepo/tools/src/lib/hooks/tools/use-route';
import { Outlet, useParams } from 'react-router-dom';
import routes from '../../../modules/routes/index.routes';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { IMFPStore } from '../../../modules/stores';
import { Page } from '@monorepo/base/src/components/page/page';
import { NestedNavPage, NestedNav, NestedNavItem, NestedNavGroup } from '../../../modules/components/base-wrappers/nested-nav/nested-nav';
import { Tooltip } from '@monorepo/controlled/src/components/tooltip/tooltip/tooltip';
import { observer } from 'mobx-react';
import { Directions } from '@monorepo/base/src/components/buttons/buttons';
import { useNavigateParams } from '@monorepo/tools/src/lib/hooks/tools/use-navigate-params';
import { AccountModel } from '../../../modules/models/account.model';
import { EntityNavigation } from '@monorepo/base/src/components/entity-navigation/entity-navigation';
import { Guard } from '../../../modules/components/guard/guard';
import { PermissionActions } from '../../../modules/enums/permissions';
import { validateAction } from '../../../modules/hooks/tools/use-guard';
import { SidebarMode } from '@monorepo/base/src/components/sidebar/sidebar';

export const AccountView = observer(() => {
	const { accountStore } = useStores<IMFPStore>();
	const sortedRows = accountStore.getSortedRows();
	const { accountId } = useParams();
	const navigate = useNavigateParams();
	const { currentRoute } = useRoute();
	useNestedSidebar({ enterMode: SidebarMode.LOCK });

	if (!accountId) {
		navigate(`${routes.accounts.index()}`, { replace: true });
		return null;
	}

	return (
		<NestedNavPage>
			<NestedNav activeRoute={currentRoute}>
				{/* <NestedNavTitle>{accountName ? accountName : <Skeleton is={true} />}</NestedNavTitle> */}
				<NestedNavItem icon={'bar-chart-square-02'} to={accountId ? `${routes.accounts.view(accountId)}` : ''}>
					Overview
				</NestedNavItem>
				<Guard validate={validateAction([PermissionActions.AdvertiserRead])}>
					<NestedNavItem icon={'building-07'} to={accountId ? `${routes.accounts.advertisers(accountId)}` : ''}>
						Advertisers
					</NestedNavItem>
				</Guard>
				<Guard validate={validateAction([PermissionActions.CampaignRead])}>
					<NestedNavItem icon={'announcement-01'} to={accountId ? `${routes.accounts.campaigns(accountId)}` : ''}>
						Campaigns
					</NestedNavItem>
				</Guard>
				<NestedNavItem icon={'globe-03'}>
					<Tooltip direction={Directions.FromLeft} content={'Coming Soon'}>
						<span>Landing Pages</span>
					</Tooltip>
				</NestedNavItem>
				<NestedNavItem icon={'timeline'}>
					<Tooltip direction={Directions.FromLeft} content={'Coming Soon'}>
						<span>Activity Log</span>
					</Tooltip>
				</NestedNavItem>
				<NestedNavItem icon={'settings-01'}>
					<Tooltip direction={Directions.FromLeft} content={'Coming Soon'}>
						<span>Settings</span>
					</Tooltip>
				</NestedNavItem>
				<NestedNavGroup title={'Placements'}>
					<NestedNavItem icon={'route'} to={accountId ? `${routes.accounts.channels(accountId)}` : ''}>
						Channels
					</NestedNavItem>
				</NestedNavGroup>
			</NestedNav>
			<Page unstyled={true}>
				<EntityNavigation<AccountModel>
					sortedRows={sortedRows}
					entityId={accountId}
					navigationRouteFunc={id => routes.accounts.advertisers(id)}
					entityName={'Accounts'}
				/>
				<Outlet />
			</Page>
		</NestedNavPage>
	);
});
